// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"4b06fe1b","410":"5b7eefb1","510":"d473e161","549":"696f08a7","630":"c71c23d0","936":"85aac379"}[chunkId] + ".chunk.js";
};